import { render, staticRenderFns } from "./FinalReportInvoicesSingleCostComparison.vue?vue&type=template&id=4948c39a&scoped=true&"
import script from "./FinalReportInvoicesSingleCostComparison.vue?vue&type=script&lang=js&"
export * from "./FinalReportInvoicesSingleCostComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4948c39a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex,VLayout})
